import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';

// cat. define
import Option from 'config/option';

const i18nConfiguration = (callback) => {
    const language = 'ko';
    const isInitialized = i18next.isInitialized;

    const rawOverrides = (typeof window !== 'undefined' && window.INTO_SETTINGS && window.INTO_SETTINGS.L10n) || null;

    const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
    const deepMerge = (target, source) => {
        if (!isObj(source)) return source ?? target;
        const out = {...(isObj(target) ? target : {})};
        Object.keys(source).forEach((k) => {
            const srcVal = source[k];
            const tgtVal = out[k];
            out[k] = isObj(srcVal) && isObj(tgtVal) ? deepMerge(tgtVal, srcVal) : srcVal;
        });
        return out;
    };

    const i18nextOptions = {
        resources: isInitialized ? i18next.store.data : undefined,

        /* Default Language */
        lng: language,

        /* fallback */
        fallbackLng: 'ko',

        /* 현재 언어만 Load */
        load: 'languageOnly',

        /* 사용할 Namespace List */
        ns: ['view_admin'],

        /* Default Namespace */
        defaultNS: 'view_admin',

        /* Debug */
        debug: false,

        /* Missing key 경고 숨김 */
        saveMissing: false,
        missingKeyHandler: false,

        /* 다국어에 동적 값을 통합 */
        interpolation: {
            escapeValue: false,
        },

        /* 비동기 로드를 위한 BackEnd Load Path 설정 */
        backend: {
            loadPath: `${Option.CONTEXT_PATH}public/asset/json/locales/{{lng}}/{{ns}}`,
            crossDomain: true,
            withCredentials: false,
        },

        /* 일부 리소스는 초기화시 설정하고 다른 리소스는 백엔드 커넥터를 사용하여 로드 */
        partialBundledLanguages: false,

        react: {
            wait: true,
            useSuspense: false,
            withRef: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
        },
    };

    i18next
        .use(HttpBackend)
        .use(initReactI18next)
        .init(i18nextOptions, () => {
            if (rawOverrides && isObj(rawOverrides)) {
                const ns = i18nextOptions.defaultNS || 'view_admin';

                Object.keys(rawOverrides).forEach((lng) => {
                    const overrideNSPayload = rawOverrides[lng];
                    if (!isObj(overrideNSPayload)) return;

                    const existing =
                        (i18next.hasResourceBundle(lng, ns)
                            ? i18next.getResourceBundle(lng, ns)
                            : {}) || {};

                    const merged = deepMerge(existing, overrideNSPayload);

                    i18next.addResourceBundle(
                        lng,
                        ns,
                        merged,
                        true,
                        true
                    );
                });
            }

            callback && callback();
        })
        .then();
};

export default i18nConfiguration;
